import { ThemeToggleInline } from '@/components/theme-toggle';
import { Text } from '@streetferret/ui-web/typography/text';
import { StreetFerretLogo } from '@streetferret/ui-web/brand';
import { Button, buttonVariants } from '@streetferret/ui-web/button';
import { Container } from '@streetferret/ui-web/container';
import { Divider } from '@streetferret/ui-web/divider';
import Link from 'next/link';
import { social } from './_lib/social';

export function PaulFooterContent({ className }: { className?: string }) {
  return (
    <div className={className}>
      <div className="flex items-center justify-between gap-1">
        <div className="space-y-1">
          <Button variant={'ghost'} asChild className="!px-1">
            <a href="https://streetferret.com">
              <div className="-mx-1">
                <StreetFerretLogo />
              </div>
            </a>
          </Button>
          <Text dimmed className="mt-2 text-left text-xs sm:mt-1 sm:text-left">
            Powered by StreetFerret
          </Text>
        </div>
        <div className="flex flex-col items-center gap-2 sm:flex-row">
          <Socials />
          <ThemeToggleInline />
        </div>
      </div>
    </div>
  );
}

export function PaulFooter() {
  return (
    <footer className="pt-20">
      <Container className="space-y-2 py-10">
        <PaulFooterContent />
      </Container>
    </footer>
  );
}

function Socials() {
  return (
    <div className="flex gap-1">
      {social.map(({ name, href, icon: Icon }) => (
        <Link
          href={href}
          className={buttonVariants({ variant: 'ghost' })}
          key={href}>
          <Icon className="h-4 w-4" />
          <span className="sr-only">{name}</span>
        </Link>
      ))}
    </div>
  );
}
